import React, { FC, useMemo } from 'react';

const Header: FC = () => {
    return useMemo(() => {
        return (
            <>
                <div id="soop-gnb" />
            </>
        );
    }, []);
};

export default Header;
